<template>
  <div>
    <span v-if="text" class="profileLink" @click="openDialog">{{ text }}</span>
    <span v-else class="profileLink" @click="openDialog"><slot /></span>
    <NumeraiModal
      ref="modal"
      :dialog="dialog"
      :button="false"
      title="You Are About to Leave Numerai"
      :width="600"
      :show-footer="false"
      @close="closeDialog"
    >
      <div>
        You are about to leave this website and visit the following url:
      </div>
      <code class="pa-3 ma-3 d-block">{{ url }}</code>
      <div class="flexrow justify_end">
        <button class="numerai-button button-tertiary" @click="closeDialog">
          Cancel
        </button>
        <button class="numerai-button red" @click="goToUrl">
          Continue
        </button>
      </div>
    </NumeraiModal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {
    NumeraiModal: () => import('@/components/shared/NumeraiModal'),
  },
  props: {
    url: { type: String, default: null },
    text: { type: String, default: null },
    onClose: { type: Function, default: null },
    logs: { type: Array, default: null },
    errorDescription: { type: String, default: null },
  },
  data: function() {
    return {
      dialog: false,
    }
  },
  computed: {
    formattedLogs() {
      if (!this.logs) {
        return
      }
      return [...this.logs].sort((a, b) => a.timestamp - b.timestamp)
    },
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      if (this.onClose) {
        this.onClose()
      }
    },
    formatTimestamp(timestamp) {
      return moment(timestamp, 'x').format('L LTS')
    },
    goToUrl() {
      window.open(this.url, '_blank', 'noopener noreferrer')
    },
  },
}
</script>

<style scoped>
h2.title {
  color: var(--color-red);
}
.profileLink {
  text-decoration: underline;
  color: var(--color-primary);
}
.profileLink:hover {
  cursor: pointer;
}
.numerai-button.red {
  background-color: var(--color-red);
  color: white;
}

.timestamp {
  width: 200px;
}
</style>
